import { create } from 'zustand'
import { persist } from 'zustand/middleware'

import type { TenantUser } from '@/types/user'

type AuthState = {
  token: string | null
  user: TenantUser | null
  setAuth: (token: string, user: TenantUser) => void
  setUser: (user: TenantUser | null) => void
  logout: () => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      user: null,
      setAuth: (token, user) => set({ token, user }),
      setUser: (user) => set({ user }),
      logout: () => set({ token: null, user: null }),
    }),
    { name: 'tenant-admin-auth' },
  ),
)
